import { LabelledUser } from 'shared/domain/user/mapping/toView';
import { CreateLevelOnView } from 'shared/domain/level/types/view';
import { DateTime } from 'luxon';

export const FORM_NAME = 'level';

export function createInitialLevelFormData(
  now: DateTime<true>,
  author: LabelledUser
): CreateLevelOnView {
  return {
    site: {
      _id: '',
      label: '',
    },
    label: '',
    deleted: false,
    createdAt: now,
    modifiedAt: now,
    modifiedBy: author,
    createdBy: author,
  };
}
